import styled from "styled-components";
import PrivilegeBg from "@/assets/images/privilege-bg.png";
export const MemberSystemWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export const UserNameIcon = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  background: var(--task-user-icon-background);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserName = styled.div`
  color: #edf7fa;
  font-weight: 600;
  font-size: 18px;
`;

export const VertifyLink = styled.button`
  all: unset;
  color: #795723;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(261.59deg, #ffbe83 0%, #fff4d8 100%);
  border-radius: 2px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
`;

export const LevelCard = styled.div`
  margin: 14px 0;
  position: relative;
  img {
    width: 298px;
    height: 68px;
  }
  div {
    position: absolute;
    bottom: 12px;
    left: 45px;
    color: #f3f8ff;
    font-size: 12px;
  }
`;
export const Privilege = styled.div`
  background: rgba(39, 41, 45, 1);
  border-radius: 8px;
  padding: 12px;
`;
export const PrivilegeTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: center;
  position: relative;
  z-index: 1;
  line-height: 22px;
  ::after {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    bottom: -2px;
    width: 100%;
    height: 6px;
    background-image: url(${PrivilegeBg});
  }
`;
export const PrivilegeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  p {
    margin: 0;
  }
  .title {
    font-size: 12px;
    font-weight: 600;
    color: #eaf4fb;
    line-height: 17px;
  }
  .sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #b2d8f0;
    line-height: 17px;
    margin-top: 2px;
  }
`;

export const BalanceTextContent = styled.div`
  background: #27292d;
  width: 100%;
  padding: 9px 0;
  border-radius: 9px 16px;
  margin-top: 8px;
  display: flex;
`;

export const BalanceText = styled.div`
  width: 50%;
  font-size: 12px;
  padding: 0 15px;
  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
  }
  .tooltip-wrapper {
    width: 100%;
    align-items: baseline;
  }
  .symbol {
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .credit {
    font-size: 22px;
    font-weight: 500;
    margin-left: 2px;
    color: rgba(255, 255, 255, 1);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.border-left {
    position: relative;
    padding-left: 17px;
    ::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto 0;
      width: 1px;
      height: 32px;
      background: #54585f;
    }
  }
`;
